<template>
  <div class="nav">
    <div class="container">
      <div class="nav_logo">
        <a href="/">
          <img :src='logo' alt=''/>
        </a>
      </div>
      <div class="nav_con">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#fff" activeTextColor='#E03535' :router="false" :unique-opened="true">
          <div v-for="(list, index) in navigatorList" :key="index" class="div_list">
            <el-submenu :index='list.url' v-if="list.children && list.children.length > 0" :router="false" :unique-opened="true">
              <template slot="title">{{list.name}}</template>
              <el-menu-item :index='child.url' v-for="(child, j) in list.children" :key="j" :route="child.url">{{child.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item :index='list.url' v-html="list.name" :route="list.url" v-else></el-menu-item>
          </div>
        </el-menu>
      </div>
      <div class="nav_right">
        <!-- <el-button type="text" @click="handleLogin">登录</el-button> -->
        <!-- <el-button type="text" @click="dialogVisible = true">登录</el-button>
        <el-dialog
          :visible.sync="dialogVisible"
          width="400px"
          center>
          <el-tabs v-model="activeName1" @tab-click="handleClick1">
            <el-tab-pane label="短信登录" name="message">短信登录</el-tab-pane>
            <el-tab-pane label="密码登录" name="pass">密码登录</el-tab-pane>
          </el-tabs>
          <el-form :model="form" v-if="messShow">
            <el-form-item>
              <el-input v-model="form.name" auto-complete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.name" auto-complete="off" placeholder="请输入短信验证码"></el-input>
            </el-form-item>
          </el-form>
          <div v-else-if="passShow"></div>
          <el-button type="info" round>登录</el-button>
          <div class="noNumber">
            <span>还没有账号？</span>
            <a href=''>立即注册</a>
          </div>
          <span slot="footer" class="dialog-footer">
            <div class="other_div">
              <p class='otherLogin'>其他登录方式</p>
              <p>
                <img :src='weixin'/>
                <img :src='QQ'/>
                <img :src='weibo'/>
              </p>
            </div>
          </span>
        </el-dialog> -->
        <!-- <ttxl-header-login :loginShow = 'loginShow'></ttxl-header-login> -->
        <!-- <el-button type="text">注册</el-button> -->
        <div class="nav_right_con" v-if="!isLogin">
          <a :href="`/login`">登录</a>
          <p class="line">/</p>
          <a :href="`/register`">注册</a>
        </div>
        <div class="nav_right_login" v-else>
          <div class="nav_right_login_ling">
            <a href='/notification'><img :src='ling' alt=""/></a>
          </div>
          <div class="nav_right_login_touxiang">
            <el-dropdown @command='ucSelect'>
              <span class="el-dropdown-link">
                <img :src='this.userinfo.avatar.small'/>
              </span>
              <el-dropdown-menu slot="dropdown" placement='bottom'>
                <el-dropdown-item v-for="(item, index) in obj" :key="index" :command="item.router">
                  <a href='javascript:void(0)'>
                    <img :src='item.img'/>
                    {{item.title}}
                  </a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="nav_search">
        <div class="search_con" ref='searchCon'>
          <a href="/cloud/search?q=心理学家大会">心理学家大会</a>
        </div>
        <div class="search_area">
          <input type="text" @focus="inputFocus" v-model='input1' ref="searchInfo" @blur='inputBlur'/>
          <a :href="`/cloud/search?q=${this.input1}`">
            <img :src="search"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TtxlHeaderLogin from '@/components/header/login'
import { getNavigation } from '@/util/api/modules/home.js'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'ttxl-header',
  components: {
    TtxlHeaderLogin
  },
  data () {
    return {
      logo: require('@/assets/home/logo.svg'),
      search: require('@/assets/home/search.png'),
      weibo: require('@/assets/home/weibo.png'),
      weixin: require('@/assets/home/weixin.png'),
      QQ: require('@/assets/home/QQ.png'),
      ling: require('@/assets/home/ling.png'),
      activeName: 'first',
      activeName1: 'message',
      loginShow: false,
      messShow: true,
      passShow: false,
      dialogVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      navigatorList: [],
      // navigatorList: [{'id': '22', 'name': '首页', 'url': '/', 'sequence': '1', 'parentId': '0', 'createdTime': '1460175875', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': []}, {'id': '1', 'name': '课程', 'url': '/coursesetfrontend/index', 'sequence': '2', 'parentId': '0', 'createdTime': '1438915365', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': []}, {'id': '38', 'name': '直播', 'url': '/live', 'sequence': '3', 'parentId': '0', 'createdTime': '1502009559', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': []}, {'id': '21', 'name': '精读', 'url': '/article', 'sequence': '5', 'parentId': '0', 'createdTime': '1460175846', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': []}, {'id': '20', 'name': '专题', 'url': '/column', 'sequence': '6', 'parentId': '0', 'createdTime': '1460175816', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '1', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': [{'id': '34', 'name': '「朱言·建瓴」朱建军视频专栏', 'url': '/column/new', 'sequence': '7', 'parentId': '20', 'createdTime': '1498033580', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}, {'id': '33', 'name': '心理危机干预与创伤辅导', 'url': '/crisis', 'sequence': '8', 'parentId': '20', 'createdTime': '1498033540', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}, {'id': '35', 'name': '用脑做管理', 'url': '/leaders', 'sequence': '9', 'parentId': '20', 'createdTime': '1498033599', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}, {'id': '36', 'name': '性少数群体专题', 'url': '/lgbt', 'sequence': '10', 'parentId': '20', 'createdTime': '1498033625', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}]}, {'id': '40', 'name': '会员', 'url': '/special/detail/tianhe', 'sequence': '11', 'parentId': '0', 'createdTime': '1502330595', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': [{'id': '42', 'name': '2018VIP会员', 'url': '/vip', 'sequence': '12', 'parentId': '40', 'createdTime': '1507984088', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '1', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}, {'id': '44', 'name': '2017福利会员', 'url': '/vip/', 'sequence': '13', 'parentId': '40', 'createdTime': '1513046221', 'updateTime': '1533554545', 'type': 'top', 'isOpen': '1', 'isNewWin': '1', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}, {'id': '43', 'name': '天和卡储值会员', 'url': '/special/detail/tianhe', 'sequence': '14', 'parentId': '40', 'createdTime': '1507984110', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '1', 'orgId': '1', 'orgCode': '1.', 'depth': 2, 'children': []}]}, {'id': '23', 'name': '事业合伙人', 'url': 'program/homepage', 'sequence': '15', 'parentId': '0', 'createdTime': '1466219796', 'updateTime': '1520579959', 'type': 'top', 'isOpen': '1', 'isNewWin': '0', 'orgId': '1', 'orgCode': '1.', 'depth': 1, 'children': []}],
      navigatorList1: [],
      navigatorList2: [],
      activeIndex: '',
      input1: '',
      obj: [
        {'title': '我的主页', router: '/user/203748', img: require('@/assets/home/zhuye.png')},
        {'title': '个人设置', router: '/settings', img: require('@/assets/home/shezhi.png')},
        {'title': '账户中心', router: '/my/coin', img: require('@/assets/home/zhanghu.png')},
        {'title': '我的学习', router: '/my/courses/learning', img: require('@/assets/home/xuexi.png')},
        {'title': '退出登录', router: '/logout', img: require('@/assets/home/tuichu.png')}
      ]
    }
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapState(['userinfo'])
  },
  methods: {
    ...mapActions(['doLogout']),
    // 点击导航跳转路由
    handleClick (e) {
      switch (e.name) {
        case 'first':
          this.$router.push({
            name: 'index',
            path: '/'
          })
          break
        case 'third':
          this.$router.push({
            name: 'live_index',
            path: '/live'
          })
          break
      }
    },
    handleClick1 (e) {
      if (e.name === 'message') {
        this.messShow = true
        this.passShow = false
      } else if (e.name === 'pass') {
        this.messShow = false
        this.passShow = true
      }
    },
    handleLogin () {
      this.loginShow = true
    },
    init () {
      getNavigation().then(data => {
        this.navigatorList = data
      })
      this.obj.forEach((item, i) => {
        if (i === 0) { item.router = `user/${this.userinfo.id}` }
      })
      // 判断权限显示管理后台
      if (this.userinfo && this.userinfo.roles) {
        let rolesLength = this.userinfo.roles.length
        for (var i = 0; i < rolesLength; i++) {
          if (this.userinfo.roles[i] === 'ROLE_USER_EMPLOYEE' || this.userinfo.roles[i] === 'ROLE_USER' || this.userinfo.roles[i] === 'ROLE_TEACHER') {
          } else {
            this.obj.push({'title': '管理后台', router: 'admin', img: require('@/assets/home/houtai.png')})
            break
          }
        }
      }
    },
    handleSelect (index, indexPath) {
      if (index !== '/' && index !== '/live') {
        window.location.href = index
      } else {
        this.$router.push({
          path: index
        })
      }
    },
    inputFocus () {
      this.$refs.searchCon.style.display = 'none'
    },
    inputBlur () {
      if (this.input1 && this.input1.length > 0) {
        this.$refs.searchCon.style.display = 'none'
      } else {
        this.$refs.searchCon.style.display = 'block'
      }
    },
    ucSelect (command) {
      window.location.href = command
      // if (command === '/logout') {
      //   this.doLogout().then(response => {
      //     this.$message({
      //       message: '退出登录成功',
      //       type: 'success',
      //       duration: 2000,
      //       onClose () {
      //         this.$router.push({
      //           name: 'index'
      //         })
      //       }
      //     })
      //   }).catch(response => {
      //     this.$message({
      //       message: '退出登录失败',
      //       type: 'error',
      //       duration: 2000
      //     })
      //   })
      // } else {
      //   window.location.href = command
      // }
    }
  },
  watch: {
    $route: function () {
      switch (this.$route.path) {
        case '/':
          this.activeIndex = '/'
          break
        case '/live':
          this.activeIndex = '/live'
          break
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="stylus">
.el-menu--horizontal>.el-submenu:focus .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title
  color #E03535!important
  background #fff!important
  // border-bottom 4px solid #E03535!important
  border-radius 2px!important
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover
  color #E03535!important
  background #fff!important
  // border-bottom 4px solid #E03535!important
  border-radius 2px!important
.nav
  width 100%
  height 80px
  box-shadow 0px 1px 4px 0px rgba(221,221,221,0.5)
  .container
    width 1180px
    height 80px
    margin 0 auto
    .nav_logo
      width 154px
      height 70px
      float left
      padding 5px 0
      img
        width 100%
        height 100%
    .nav_con
      float left
      height 80px
      width 660px
      padding-left 8px
      padding-right 10px
      .el-menu-demo
        height 80px
        margin 0
        border-bottom none
        .div_list
          float left
          border none
          outline none
          .el-menu-item
            height 70px
            font-size 16px
            font-family MicrosoftYaHeiUI
            color #666
            margin 10px 20px 0
            padding 0
            border none
          .el-menu-item:focus, .el-menu-item:hover
            background #fff!important
            color #E03535!important
            // border-bottom-color #E03535!important
          .el-menu-item.is-active
            // border-bottom 4px solid #e03535 !important
          .el-menu-item.is-opened
            color #E03535!important
          // .el-menu-item:after
          //   content ""
          //   display inline-block
          //   position absolute
          //   bottom 15px
          //   left calc(50% - 7px)
          //   width 14px
          //   height 4px
          //   background #E03535
          .el-submenu
            .el-submenu__title
              font-size 16px
              height 70px
              color #666
              padding 0
              margin 10px 20px 0
              .el-submenu__icon-arrow
                display block
                right -16px
                margin-top -13px
    .nav_search
      float right
      width 186px
      height 80px
      position relative
      .search_con
        position absolute
        bottom 30px
        z-index 100
        a
          height 25px
          line-height 25px
          background rgba(242,243,247,1)
          border-radius 15px
          display block
          float left
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(51,51,51,1)
          margin-right 11px
          text-align center
          text-decoration none
          padding 0 11px
      .search_area
        border 0 solid #fff
        width 100%
        border-bottom 1px solid #DDDDDD
        position absolute
        bottom 17px
        height 44px
        text-align left
        padding-top 24px
        input
          border none
          height 40px
          float left
          width 100%
          outline none
          font-size 12px
          padding 0 10px
          color #333
        img
          float left
          width 25px
          height 25px
          position absolute
          right 10px
          top 32px
    .nav_right
      float right
      padding-top 20px
      width 155px
      // padding-left 23px
      // .el-button--text
      //   float left
      //   font-size 16px
      //   font-family MicrosoftYaHeiUI
      //   color rgba(102,102,102,1)
      //   padding-top 17px
      .nav_right_con
        padding-left 30px
        a
          float left
          font-size 16px
          font-family MicrosoftYaHeiUI
          color rgba(102,102,102,1)
          padding-top 17px
          text-decoration none
        p
          float left
          font-size 16px
          font-family MicrosoftYaHeiUI
          color rgba(102,102,102,1)
        .line
          padding 1px 4px
      .nav_right_login
        overflow hidden
        margin 0 20px
        .nav_right_login_ling
          width 38px
          height 38px
          float left
          margin-right 25px
        .nav_right_login_touxiang
          width 38px
          height 38px
          float left
          .el-dropdown
            span
              img
                width 38px
                height 38px
                border-radius 50%
.el-dropdown-menu
  width 172px
  padding 0
  .el-dropdown-menu__item
    height 45px
    line-height 45px
    padding 0
    a
      float left
      text-decoration none
      color #333
      font-size 14px
      width 172px
      height 45px
      img
        float left
        // width 20px
        // height 20px
        padding-top 8px
        margin-right 10px
        margin-left 15px
.el-submenu__title:focus, .el-submenu__title:hover
  color #E03535!important
  background #fff!important
  // border-bottom 4px solid #E03535!important
  border-radius 2px!important
//     .el-dialog__wrapper
//       .el-dialog--center
//         .el-dialog__header
//           padding 0
//           position relative
//           height 64px
//           .el-dialog__title
//             width 64px
//             height 64px
//             display block
//             background url('~@/assets/home/erCode.png') no-repeat center center
//             position absolute
//             right 0
//           .el-dialog__headerbtn
//             width 32px
//             height 69px
//             background url('~@/assets/home/close.png') no-repeat center center
//             bottom -894px
//             right 180px
//             .el-icon-close:before
//               display none
//         .el-dialog__body
//           padding 0px 60px
//           border-bottom 1px solid #EEEEEE
//           .el-tabs--top
//             .el-tabs__header
//               .el-tabs__nav-wrap
//                 display block
//                 .el-tabs__item
//                   width 75%
//                   text-align center
//                   padding 0 4px
//                   font-size 22px
//                   font-family MicrosoftYaHeiUI
//                   color #999999
//                   line-height 30px
//                 .el-tabs__item:hover
//                   color #333
//                 .el-tabs__item.is-active
//                   color #333
//                 .el-tabs__active-bar
//                   display none
//               .el-tabs__nav-wrap::after
//                 display none
//             .el-tabs__content
//               display none
//           .el-form
//             .el-form-item
//               .el-form-item__content
//                 margin-left 0
//                 .el-input__inner
//                   border none
//                   border-bottom 1px solid #666
//                   border-radius 0
//                   padding 0
//           .el-button--small.is-round
//             border 0
//             width 290px
//             height 46px
//             background rgba(201,204,209,1)
//             border-radius 23px
//             font-size 16px
//             font-family MicrosoftYaHeiUI
//             color rgba(255,255,255,1)
//             letter-spacing 16px
//             margin-top 10px
//           .noNumber
//             font-size 14px
//             font-family MicrosoftYaHeiUI
//             line-height 19px
//             margin 30px auto
//             text-align center
//             span
//               color #333
//             a
//               color #F55B50
//               text-decoration none
//         .el-dialog__footer
//           height 100px
//           padding 26px 0
//           margin 0 auto
//           width 262px
//           .dialog-footer
//             .other_div
//               .otherLogin
//                 font-size 18px
//                 color #333
//                 margin-right 16px
//               p
//                 img
//                   width 28px
//                   height 28px
//                   float left
//                   margin-right 16px
//                 img:hover
//                   cursor pointer
// .el-menu--horizontal
//   .el-menu
//     .el-menu-item
//       color #666
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue